export function getMergrAry(data, key) {
	let flage = 0
	let flageAry = []
	let resAry = []
	for (let i = 0; i < data.length; i++) {
		if (i == 0) {
			resAry.push(1)
			flageAry.push(data[0][key])
			flage = 0
			console.log(flageAry)
		} else {
			if (flageAry.indexOf(data[i][key]) > -1) {
				resAry[flage] += 1
				resAry.push(0)
			} else {
				resAry.push(1)
				flageAry.push(data[i][key])
				console.log(flageAry)
				flage = i
			}
		}
	}
	return resAry
}
